import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, Modal, notification, Select } from "antd";
import api from "../../../services/api";
import { useEffect, useState } from "react";

export default function ModalStatus({ exibirModal, fecharModalStatus, dadosStatus, onSave }) {

    const [formulario] = Form.useForm();
    const [statusSelecionado, setStatusSelecionado] = useState(null);
    const [listaStatus, setListaStatus] = useState([]);


    useEffect(() => {
        api.get(`StatusPedido/Listar`).then(res => {
            setListaStatus(res.data.items);
        });
    }, []);

    useEffect(() => {
        if (exibirModal) {
            formulario.resetFields();
            setStatusSelecionado(null);
        }
    }, [exibirModal]);


    function alterarStatus() {
        if (!statusSelecionado) {
            notification.warning("Selecione um status!");
            return;
        }
        let observacao = formulario.getFieldValue("peh_observacao");
        let dadosAtualizados = {
            ped_id: dadosStatus.ped_id,
            stp_id: statusSelecionado,
            peh_observacao: observacao
        };
        api.put(`OrdemServico/EditarStatus`, dadosAtualizados)
            .then(() => {
                notification.success({ message: 'Concluído!', description: "Status alterado com sucesso!" })
                onSave();
            })
            .catch(error => {
                console.log(error);
            }).finally(() => {

                fecharModalStatus();
            })
    }

    return (
        <Modal centered
            title="Alterar Status da OS"
            open={exibirModal}
            destroyOnClose
            onCancel={fecharModalStatus}
            width={500}
            footer={[
                <Button icon={<CloseOutlined />} size="middle" onClick={fecharModalStatus}>
                    Cancelar
                </Button>,
                <Button type="primary" size="middle" icon={<CheckOutlined />} onClick={alterarStatus}>
                    Alterar
                </Button>,
            ]}>
            <div >
                <Form form={formulario} >
                    <Col span={24}>
                        <Form.Item name="stp_id" label="Status">
                            <Select optionFilterProp="children" allowClear placeholder="Selecione o novo Status para OS"
                                value={statusSelecionado}
                                onChange={setStatusSelecionado}>
                                {listaStatus.map((item) => (
                                    <Select.Option value={item.stp_id} key={item.stp_id} label={item.stp_descricao}>{item.stp_descricao}</Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item label="Observações" name="peh_observacao">
                            <Input.TextArea
                                autoSize={{
                                    minRows: 2,
                                    maxRows: 6,
                                }}
                                maxLength={100} />
                        </Form.Item>
                    </Col>
                </Form>
            </div>
        </Modal>
    );
}